import { ShowButton, TopToolbar } from 'react-admin'
import { Box, Button } from '@mui/material'
import { Delete, Save } from '@mui/icons-material'

// Edit-page actions at the top: Show on the left, like the Users Edit page's
// header but left-aligned (Table Standards -> record-page actions).
export const EditPageActions = (
  <TopToolbar sx={{ justifyContent: 'flex-start' }}>
    <ShowButton />
  </TopToolbar>
)

// The bottom row of an Edit page whose form is not a react-admin form: Save on
// the left and the destructive Delete at the far end, the same order as the
// Users Edit toolbar. Delete is omitted when onDelete isn't given.
export function EditPageToolbar({ saveLabel, onSave, saveDisabled, deleteLabel, onDelete, deleteDisabled }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
      <Button variant="contained" startIcon={<Save />} onClick={onSave} disabled={saveDisabled}>
        {saveLabel}
      </Button>
      {onDelete && (
        <Button color="error" startIcon={<Delete />} onClick={onDelete} disabled={deleteDisabled}>
          {deleteLabel}
        </Button>
      )}
    </Box>
  )
}
